export default __webpack_public_path__ + "static/media/logo-footer.120dea1c.png";